
import AnimatedSection from '../components/AnimatedSection';
import CompanyLogo from '../components/CompanyLogo';
// --- Hero Section ---
// --- Hero Section ---
const Hero = ({ onContactClick }) => {
    // Función para manejar el scroll suave
    const handleSmoothScroll = (e, targetId) => {
        e.preventDefault();
        document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <AnimatedSection id="hero" className="min-h-screen flex flex-col justify-center items-start relative overflow-hidden">
            <div className="absolute top-0 left-0 -translate-x-1/4 -translate-y-1/4 w-96 h-96 bg-cyan-500/20 rounded-full filter blur-3xl opacity-50 animate-pulse"></div>
            <div className="absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4 w-96 h-96 bg-blue-500/20 rounded-full filter blur-3xl opacity-50 animate-pulse animation-delay-4000"></div>
            <div className="relative z-10">
                <p className="text-cyan-400 mb-2">Alan Gerónimo</p>
                <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight">Senior Android Developer</h1>
                <h2 className="text-2xl md:text-3xl font-medium text-slate-300 mt-2">Kotlin · Jetpack Compose · Clean Architecture</h2>
                <p className="mt-6 max-w-2xl text-slate-400 text-lg">
                    I transform complex problems into elegant, high-performance mobile applications that users love, specializing in scalable solutions for the fintech and enterprise sectors.
                </p>
                <div className="mt-8 flex gap-4">
                    <a href="#projects" onClick={(e) => handleSmoothScroll(e, 'projects')} className="inline-flex items-center gap-2 bg-cyan-500 text-white font-semibold py-3 px-6 rounded-lg hover:bg-cyan-600 transition-all duration-300 shadow-lg shadow-cyan-500/20">
                        View My Work
                    </a>
                    <button onClick={onContactClick} className="inline-flex items-center gap-2 bg-slate-800 text-white font-semibold py-3 px-6 rounded-lg hover:bg-slate-700 transition-all duration-300">
                        Contact Me
                    </button>
                </div>

                {/* --- Sección de Logos de Empresas --- */}
                <div className="mt-20 max-w-2xl">
                    <p className="text-sm font-semibold text-slate-400 tracking-wider uppercase">
                        Proven experience at industry-leading companies
                    </p>
                    <div className="mt-6 flex items-center gap-x-10 gap-y-4 flex-wrap">
                        <CompanyLogo name="PayPal" />
                        <CompanyLogo name="Venmo" />
                        <CompanyLogo name="Limeade" />
                        <CompanyLogo name="December Labs" />
                    </div>
                </div>
            </div>
        </AnimatedSection>
    );
};

export default Hero;